import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { container as containerClass } from './container.module.css';
export const Container = forwardRef(({ children, className, padding = false, dimension = 'full', as: Wrapper = 'div', ...props }, forwardedRef) => (React.createElement(Wrapper, { ref: forwardedRef, className: clsx(containerClass, className), "data-dimension": dimension, "data-padding": padding, ...props }, children)));
Container.displayName = 'Container';
